export const APPLICATION_TYPES = [
    {
        label : 'Edetail',
        id : 1
    },
    {
        label : 'Emailer',
        id : 2
    }
]